import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Tooltip,
  InputAdornment,
  Box,
  Typography,
} from '@mui/material';
import { Percent as PercentIcon } from '@mui/icons-material';
import { getIgvPercent, setIgvPercent } from '../../config/igv';

const IgvSettings: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(String(getIgvPercent()));

  const handleOpen = () => {
    setValue(String(getIgvPercent()));
    setOpen(true);
  };

  const handleSave = () => {
    const num = Number(value);
    if (isNaN(num) || num < 0 || num > 100) return;
    setIgvPercent(num);
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="Configurar IGV">
        <IconButton onClick={handleOpen} sx={{ color: '#6B7280' }} size="small">
          <PercentIcon />
        </IconButton>
      </Tooltip>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Configurar IGV</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Porcentaje de IGV aplicado en los calculos del sistema.
          </Typography>
          <TextField
            fullWidth
            label="IGV"
            type="number"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            inputProps={{ min: 0, max: 100, step: 0.1 }}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            autoFocus
          />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setOpen(false)}>Cancelar</Button>
          <Button variant="contained" onClick={handleSave} disabled={isNaN(Number(value)) || Number(value) < 0 || Number(value) > 100}>
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default IgvSettings;
